import {NgModule}       from '@angular/core';
import {CommonModule}   from '@angular/common';
import {FormsModule}    from '@angular/forms';

import {FileUploadModule} from 'primeng/primeng';
import {InputTextareaModule} from 'primeng/primeng';
import {InputTextModule} from 'primeng/primeng';
import {DropdownModule} from 'primeng/primeng';
import {TooltipModule} from 'primeng/primeng';
import {ChipsModule} from 'primeng/primeng';
import {ButtonModule} from 'primeng/primeng';
import {DialogModule} from 'primeng/primeng';
import {TableModule} from 'primeng/table';
import {OrderListModule} from 'primeng/primeng';
import {ListboxModule} from 'primeng/primeng';
import {MessagesModule} from "primeng/primeng";
import {MessageModule} from "primeng/primeng";

import {JsonSchemaFormModule, Bootstrap3FrameworkModule} from 'angular2-json-schema-form';
import {MomentModule} from 'angular2-moment';

import {pagesRouting} from './pages.routing'

import {PageListComponent} from './page-list.component';
import {PageFormComponent} from './page-form.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FileUploadModule,
        InputTextareaModule,
        InputTextModule,
        DropdownModule,
        TooltipModule,
        ChipsModule,
        ButtonModule,
        DialogModule,
        TableModule,
        OrderListModule,
        ListboxModule,
        MessagesModule,
        MessageModule,
        MomentModule,
        pagesRouting,
        JsonSchemaFormModule,
        Bootstrap3FrameworkModule
    ],
    declarations: [
        PageListComponent,
        PageFormComponent
    ]
})
export class PagesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/pages/pages.module.ts